import React from 'react'
// import { useParams } from 'react-router-dom'

const Contect = () => {
// const { fnamee } =useParams()
  return (
    <div><h1 style={{"text-align":"center"}}>THIS IS CONTECT PAGE  </h1></div>
  )
}

export default Contect